import { FormBuilderSection, FormBuilderSectionProperty } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { StaticConfig } from '../../../state/configuration'
import { INPUT_SECTION_CLASS } from '../options'
import { StaticDivider, StaticHeading } from '../static'

export interface FormContentStaticProps {
  t: TFunction
  tKey: TKeyBuilder
  item: StaticConfig
  variant?: FormBuilderSectionProperty
}

export const FormContentStatic: FunctionComponent<FormContentStaticProps> = ({
  t,
  tKey,
  item,
  variant,
}) => {
  const component = (() => {
    switch (item.type) {
      case 'divider':
        return <StaticDivider key={item.name} />
      case 'heading':
        return <StaticHeading tKey={tKey} t={t} item={item} />
    }
  })()

  return (
    <FormBuilderSection
      key={item.name}
      id={item.name}
      width={1}
      variant={variant}
      className={INPUT_SECTION_CLASS}
    >
      {component}
    </FormBuilderSection>
  )
}
